import { j as g } from "./jsx-runtime-3tyXYecC.mjs";
import { f as s } from "./index-LyFokDcn.mjs";
import { m as T } from "./tss-DN0acMKN.mjs";
import { M as k, d as j } from "./constants-CnFYFetN.mjs";
import { g as f } from "./get-encore-value-Di648HqV.mjs";
import { B } from "./base-icon-v2-DZwX3wnO.mjs";
const b = T()((a, o) => {
  const { constructs: e, mode: p, palette: i, spacing: m, typography: t } = a, { color: h, icon: x, inline: n, italic: y, justify: l, size: r, tabularNums: u, weight: c, whiteSpace: F } = o, v = () => {
    if (r && ["emphasis-small", "emphasis-medium"].includes(r))
      return {
        "emphasis-small": t.h4.fontFamily,
        "emphasis-medium": t.h3.fontFamily
      }[r];
  }, w = () => {
    var d;
    return r && ["emphasis-extra-small", "emphasis-small", "emphasis-medium"].includes(r) ? {
      "emphasis-extra-small": t.h5.lineHeight,
      "emphasis-small": t.h4.lineHeight,
      "emphasis-medium": t.h3.lineHeight
    }[r] : f(r, {
      // The line heights for small and teenie are wrong in our theme, so we'll hard-code the right values
      "extra-extra-small": "15px",
      "extra-small": s.ifFeature("encore", (d = t.xsmall) == null ? void 0 : d.lineHeight, "17px"),
      small: s.ifFeature("encore", t.small.lineHeight, "19px"),
      medium: t.medium.lineHeight,
      large: t.large.lineHeight
    });
  }, H = () => r && ["emphasis-extra-small", "emphasis-small", "emphasis-medium"].includes(r) ? {
    "emphasis-extra-small": t.h5.fontSize,
    "emphasis-small": t.h4.fontSize,
    "emphasis-medium": t.h3.fontSize
  }[r] : f(r, {
    "extra-extra-small": "11px",
    "extra-small": t.teenie.fontSize,
    small: t.small.fontSize,
    medium: t.medium.fontSize,
    large: t.large.fontSize
  }), S = f(h, {
    primary: s.ifFeature("encore", e.text.primary.strong, i.primary.main),
    success: s.ifFeature("encore", e.text.success.medium, i.success.dark),
    "success-medium": e.text.success.medium,
    "success-strong": e.text.success.strong,
    error: s.ifFeature("encore", e.text.error.medium, i.error.dark),
    "error-medium": e.text.error.medium,
    "error-strong": e.text.error.strong,
    warning: s.ifFeature("encore", e.text.warning.medium, i.warning.dark),
    "warning-medium": e.text.warning.medium,
    "warning-strong": e.text.warning.strong,
    info: s.ifFeature("encore", e.text.info.medium, i.info.dark),
    "info-medium": e.text.info.medium,
    "info-strong": e.text.info.strong,
    discovery: s.ifFeature("encore", e.text.discovery.medium, i.discovery.dark),
    "discovery-medium": e.text.discovery.medium,
    "discovery-strong": e.text.discovery.strong,
    "neutral-weak": s.ifFeature("encore", e.text.neutral.weak, i.gray[700]),
    "neutral-medium": s.ifFeature("encore", e.text.neutral.medium, i.gray[800]),
    "neutral-strong": s.ifFeature("encore", e.text.neutral.strong, i.gray[1e3]),
    "neutral-extra-strong": s.ifFeature("encore", e.text.neutral.xStrong, i.gray[1e3]),
    "neutral-inverted": s.ifFeature("encore", e.text.neutral.inverted)
  }), M = w();
  let z;
  return n ? z = "inline" : x && (z = "flex"), {
    root: {
      color: S,
      display: z,
      fill: S,
      fontFamily: v(),
      fontSize: H(),
      fontStyle: y ? "italic" : void 0,
      fontVariantNumeric: u ? "tabular-nums" : "inherit",
      fontWeight: f(c, {
        regular: t.fontWeightRegular,
        medium: t.fontWeightMedium,
        semibold: t.fontWeightSemibold,
        bold: t.fontWeightBold
      }),
      justifyContent: l,
      lineHeight: n ? "1lh" : M,
      margin: 0,
      outline: p === k.Dye ? `1px solid ${j.main}` : void 0,
      overflowWrap: "anywhere",
      padding: 0,
      textAlign: l,
      whiteSpace: F,
      wordBreak: "normal",
      verticalAlign: n ? "top" : void 0
    },
    icon: {
      alignItems: "center",
      display: "inline-flex",
      height: "1lh",
      marginRight: r && ["emphasis-extra-small", "emphasis-small", "emphasis-medium"].includes(r) ? m(1.5) : m(1),
      verticalAlign: n ? "top" : void 0
    }
  };
});
function W(a) {
  return a && {
    "emphasis-extra-small": 20,
    "emphasis-small": 20,
    "emphasis-medium": 24,
    "extra-extra-small": 12,
    "extra-small": 12
  }[a] || 16;
}
function E({
  children: a,
  color: o,
  component: e,
  containerRef: p,
  icon: i,
  id: m,
  inline: t,
  italic: h,
  justify: x,
  size: n,
  tabularNums: y = !1,
  weight: l,
  whiteSpace: r
}) {
  const { classes: u } = b({ color: o, icon: i, inline: t, italic: h, justify: x, size: n, tabularNums: y, weight: l, whiteSpace: r }), c = W(n), F = e || "p";
  return /* @__PURE__ */ g.jsxs(F, { className: u.root, "data-fabric-component": "BodyText", id: m, ref: p, children: [
    i && /* @__PURE__ */ g.jsx("span", { className: u.icon, children: s.ifFeature(
      "encore",
      typeof i == "string" ? /* @__PURE__ */ g.jsx(B, { fill: "currentColor", height: c, name: i, width: c }) : i,
      i
    ) }),
    i && !t ? /* @__PURE__ */ g.jsx("span", { children: a }) : a
  ] });
}
export {
  E as B
};
//# sourceMappingURL=body-text-BiQwh5-U.mjs.map
